import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";
import axiosPrivate from "../../../src/core/api/axiosClientPrivate";

const initialState: any = {
  assetTableStatus: [],
  isLoadingAssetTableStatus: false,
  assets: [],
  assetsFilter: {},
  assetMainSearchFilter: {
    townCouncil: null,
    site: null,
    block: null,
    level: null,
  },
  isLoadingAssets: false,
  assetsByGroup: [],
  isLoadingAssetsByGroup: false,
  assetsByParent: [],
  isLoadingAssetsByParent: false,
  allAssetsByParentAndType: [],
  isLoadingAllAssetsByParentAndType: false,
  assetDetails: {},
  isLoadingAssetDetails: false,
  townCouncils: [],
  assetDetailsData: {},
  isLoadingAssetDetailsData: false,
  sites: [],
  blocks: [],
  assetchildren: [],
  burnChartData: [],
  isLoadingBurnChartData: false,
  daylightReadingChartData: [],
  isLoadingDaylightReadingChartData: false,
  energyConsumptionData: [],
  isLoadingEnergyConsumptionData: false,
  motionTrafficData: [],
  isLoadingMotionTrafficData: false,
  lighteningParameters: [],
  isLoadingLighteningParameters: false,
  lightingOverrides: [],
  isLoadingLightingOverrides: false,
  softDimmings: [],
  isLoadingSoftDimmings: false,
  lightIntensities: [],
  isLoadingLightIntensities: false,
  timeDelays: [],
  isLoadingTimeDelays: false,
  sensorParameters: [],
  isLoadingSensorParameters: false,
  triggeringZones: [],
  selectedAssetType: null,
  luminanceProfiles: null,
  isLoadingLuminanceProfiles: false,
  isLoading: false,
  error: null,
  uploadStatusIsSuccess: false,
  breadCrumbInfo: [],
  operationModes: [],
  isLoadingOperationModes: false,
  detectionRanges: [],
  isLoadingDetectionRanges: false,
  assetSummary: {},
  isLoadingAssetSummary: false,
  assetsWithLocation: [],
  isLoadingAssetsWithLocation: false,
  motionSensor: [],
  isLoadingMotionSensor: false,
  photoSensor: [],
  isLoadingPhotoSensor: false,
  rainSensor: [],
  isLoadingRainSensor: false,
  searchedAssets: [],
  isLoadingSearchedAssets: false,
  searchedAssetsByGateway: [],
  isLoadingsearchedAssetsByGateway: false,
  assetRealTimeConfigData: {},
  assetRealTimeConfigDataForSensorParameter: {},
  lightProfileSocketData: {},
  assetsPendingStatus: false,
  selectedAssets: [],
  isSelectionModalOpen: false,
  isAnalyticsModalOpen: false,
  analyticsDate: "",
  lightGroups: [],
  selectedGroupsAssets: [],
  isLoadingLightGroups: false,
  groupsByAssets: [],
  isLoadingGroupsByAsset: false,
  daysOfWeek: [],
  isLoadingDaysOfWeek: [],
  isLoadingTimerProfile: false,
  isLoadingDimmingProfile: false,
  isLoadingLumminanceProfile: false,
  proximityLighting: [],
  isLoadingProximityLighting: false,
  getProximityLightingDetails: [],
  isLoadingGetProximityLighting: false,
  updateProximityLightingDetails: [],
  isLoadingUpdateProximityLighting: false,
  timerProfileDetails: {},
  dimmingProfileDetails: {},
  luminanceProfileDetails: {},
  selectedAssetsByBlock: [],
  isLoadingSelectedAssetsByBlock: false,

  selectedAssetsByBlockAndType: [],
  isLoadingSelectedAssetsByBlockAndType: false,
  isLoadingSaveToGatewayGroup: false,
  isUpdatingGroupAssets: false,
  isLoadingActiveLightTest: false,
  isLoadingELightTest: false,
  isLoadingELightAutoTest: false,
  testTypes: [],

  resetAssetDetails: [],
  isLoadingResetAssetDetails: false,

  assetSensorInfo: [],
  isLoadingAssetSensorInfo: false,
  gatewayByBlockCode: [],
  isLoadingGatewayByBlockCode: false,

  lightType: [],
  isLoadingLightType: false,

  assetDeploymentType: [],
  isLoadingAssetDeploymentType: false,

  socketRealTimeUpdate: {
    LightingOverride: false,
    SoftDimming: false,
    LightIntensity: false,
    TimeDelay: false,
    MotionSensor: false,
    PhotoSensing: false,
    RainSensor: false,
    TimerProfile: false,
    DimmingProfile: false,
    LuminanceProfile: false,
    DayLightProfile: false,
    RainProfile: false,
    DayLightHarvest: false,
    LightStatusReading: false,
    GetGatewayConfigFromDevice: false,
    GeneralConfiguration: false,
    GetTimerProfileConfigFromDevice: false,
    GetDaylightProfileConfigFromDevice: false,
    GatewayZoneSetACK: false,
  },
  socketData: {},
  socketRealTimeUpdateData: {},

  selectedAssetCode: "",

  assetExport: [],
  isLoadingAssetExport: false,
  isLoadingBlocksExport: false,
  isLoadingPredictiveLighting: false,
  isLoadingCommandToDms: false,
  isLoadingGroupAckInfoByGateway: false,
  groupAckInfoByGateway: [],
  isLoadingGroupUnAckInfoByGateway: false,
  groupUnAckInfoByGateway: [],
};

export const uploadAssetFile: any = createAsyncThunk(
  "content/uploadAssetFile",
  async ({ formData, onUploadProgress }: any) => {
    const response = await axiosPrivate.post(
      `/slpapp/Asset/InsertAssetByFile`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
      },
    );

    return response?.data;
  },
);

export const compareAssetLocationFromExcel: any = createAsyncThunk(
  "content/compareAssetLocationFromExcel",
  async ({
    file,
    operationKey,
    pageNumber = 1,
    pageSize = 10,
    sortBy,
    sortDirection,
    isChanged = false,
  }: any) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axiosPrivate.post(
      `/slpapp/Asset/CompareAssetLocationFromExcel`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: {
          operationKey,
          pageNumber,
          pageSize,
          sortBy,
          sortDirection,
          isChanged,
        },
      },
    );

    return response?.data;
  },
);

export const updateAssetLocationFromExcel: any = createAsyncThunk(
  "content/updateAssetLocationFromExcel",
  async ({ operationKey }: any) => {
    const response = await axiosPrivate.post(
      `/slpapp/Asset/UpdateAssetLocationFromExcel`,
      null,
      {
        params: { operationKey },
      },
    );

    return response?.data;
  },
);

export const getAssetUploadStatus: any = createAsyncThunk(
  "content/getAssetUploadStatus",
  async ({ jobId }: any) => {
    const response = await axiosPrivate.get(
      `/slpapp/Asset/AssetUploadStatus?jobId=${jobId}`,
    );

    return response?.data;
  },
);

export const exportAssets: any = createAsyncThunk(
  "content/exportAssets",
  async ({
    tcCode = "",
    siteCode = "",
    blockCode = "",
    assetTypeId = 0,
    isActive = false,
    status = "",
    searchText = "",
    sortBy = "",
    sortDirection = "",
  }: any) => {
    const payload = {
      tcCode,
      siteCode,
      blockCode,
      assetTypeId,
      isActive,
      status,
      searchText,
      sortBy,
      sortDirection,
    };

    try {
      const response = await axios.post(
        `/slpapp/Asset/getAsset/downloadExcel`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        },
      );

      let filename = response.headers["content-disposition"]
        .split(";")
        .find((n: any) => n.includes("filename="))
        .replace("filename=", "")
        .trim();

      const fileBlob = new Blob([response.data], {
        type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;

      link.download = filename;

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading fault report:", error);
      throw error;
    }
  },
);

export const downloadBySiteOrBlock: any = createAsyncThunk(
  "content/downloadBySiteOrBlock",
  async ({ siteCode = "", blockCode = "" }: any) => {
    try {
      const response = await axios.post(
        `/slpapp/Asset/getAsset/downloadBySiteOrBlock`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: { siteCode, blockCode },
          responseType: "blob",
        },
      );

      const contentDisposition = response.headers["content-disposition"];
      const filenamePart = contentDisposition
        ?.split(";")
        .find((n: any) => n.includes("filename="));

      const getFallbackFilename = () => {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const yyyy = today.getFullYear();
        return `${siteCode}_Asset_List(${dd}-${mm}-${yyyy}).xlsx`;
      };

      const filename = filenamePart
        ? filenamePart
            .replace("filename=", "")
            .trim()
            .replace(/^["']|["']$/g, "")
        : getFallbackFilename();

      const fileBlob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();

      setTimeout(() => URL.revokeObjectURL(fileUrl), 100);

      return response.data;
    } catch (error) {
      console.error("Error downloading fault report:", error);
      throw error;
    }
  },
);

export const exportFloorplanLights: any = createAsyncThunk(
  "content/exportFloorplanLights",
  async ({
    tcCode,
    siteCode,
    blockCode,
    assetTypeId,
    isActive,
    status,
    isInFloorPlan,
    searchText,
    sortBy,
    sortDirection,
  }: any) => {
    const payload = {
      tcCode,
      siteCode,
      blockCode,
      assetTypeId,
      isActive,
      status,
      isInFloorPlan,
      searchText,
      sortBy,
      sortDirection,
    };

    try {
      const response = await axios.post(
        `/slpapp/Asset/getAsset/downloadFloorPlanAssetExcel`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        },
      );

      let filename = response.headers["content-disposition"]
        .split(";")
        .find((n: any) => n.includes("filename="))
        .replace("filename=", "")
        .trim();

      const fileBlob = new Blob([response.data], {
        type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;

      link.download = filename;

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading fault report:", error);
      throw error;
    }
  },
);

export const downloadValidationReport: any = createAsyncThunk(
  "content/downloadValidationReport",
  async (jobId: string) => {
    try {
      const response = await axios.get(
        `/slpapp/Asset/DownloadValidationReport?jobId=${jobId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        },
      );

      const contentDisposition = response.headers["content-disposition"];
      let filename = "ValidationReport.xlsx";
      if (contentDisposition) {
        let filenameMatch = contentDisposition
          .split(";")
          .find((n: any) => n.includes("filename="));
        if (filenameMatch) {
          filename = filenameMatch
            .replace("filename=", "")
            .trim()
            .replace(/^["']|["']$/g, "");
        }
      }

      const fileBlob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;

      link.download = filename;

      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(fileUrl), 100);

      return response.data;
    } catch (error) {
      console.error("Error downloading validation report:", error);
      throw error;
    }
  },
);

export const exportTotalBlocks: any = createAsyncThunk(
  "content/exportTotalBlocks",
  async ({
    tcCode,
    siteCode,
    siteProjectTypeId,
    sortBy,
    sortDirection,
  }: any) => {
    const payload = {
      tcCode,
      siteCode,
      siteProjectTypeId,
      sortBy,
      sortDirection,
    };

    try {
      const response = await axios.post(
        `/slpapp/Site/downloadSiteSummaryCSV`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        },
      );

      let filename = response.headers["content-disposition"]
        .split(";")
        .find((n: any) => n.includes("filename="))
        .replace("filename=", "")
        .trim();

      const fileBlob = new Blob([response.data], {
        type: "text/csv",
      });

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;

      link.download = filename;

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading blocks export:", error);
      throw error;
    }
  },
);

export const getAssets: any = createAsyncThunk(
  "content/getAssets",
  async ({
    PageNumber,
    pageSize,
    tcCode = null,
    siteCode = null,
    blockCode = null,
    isActive = null,
    isOnline = null,
    SortBy,
    SortDirection,
    searchText,
  }: any) => {
    const res = await axios.get(`/slpapp/Asset/getall`, {
      params: {
        PageNumber,
        pageSize,
        tcCode,
        siteCode,
        blockCode,
        isActive,
        isOnline,
        SortBy,
        SortDirection,
        searchText,
      },
    });

    const data = await res.data;
    return data;
  },
);

export const updateAssetLocation: any = createAsyncThunk(
  "content/updateAssetLocation",
  async ({ assetCode, displayLocationId, blockCode, floorCode }: any) => {
    const res = await axios.put(
      `/slpapp/Asset/UpdateAssetLocation`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
        params: { assetCode, displayLocationId, blockCode, floorCode },
      },
    );

    const data = await res.data;
    return data;
  },
);

export const getAssetsByGroup: any = createAsyncThunk(
  "content/getAssetsByGroup",
  async (params: any) => {
    const res = await axios(`/slpapp/Asset/byLocation`, {
      params: params,
    });
    const data = await res.data.data.assetGroups;
    return data;
  },
);

export const getAssetByCode: any = createAsyncThunk(
  "content/getAssetByCode",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/Asset/assetDetailInfo`, {
      params: { assetCode: id },
    });

    const data = await res.data.data;

    // debugger;
    return data;
  },
);

export const getAssetSingleAssetByCode: any = createAsyncThunk(
  "content/getAssetSingleAssetByCode",
  async ({ assetCode }: any) => {
    const res = await axios.get(`/slpapp/Asset/ByCode`, {
      params: { assetCode },
    });

    const data = await res.data.data;
    return data;
  },
);

export const getGatewayByBlockCode: any = createAsyncThunk(
  "content/getGatewayByBlockCode",
  async ({ blockCode }: any) => {
    const res = await axios.get(`/slpapp/Asset/GatewayByBlockCode`, {
      params: { blockCode, isForSite: true },
    });

    const data = await res?.data?.data;
    return data;
  },
);

export const getLightType: any = createAsyncThunk(
  "content/getLightType",
  async () => {
    const res = await axios.get(`/slpapp/LightType/getall`);

    const data = await res.data.data;
    return data;
  },
);

export const getAssetDeploymentType: any = createAsyncThunk(
  "content/getAssetDeploymentType",
  async () => {
    const res = await axios.get(`/slpapp/AssetDeploymentType`);

    const data = await res?.data;
    return data;
  },
);

export const getTownCouncils: any = createAsyncThunk(
  "content/getTownCouncils",
  async () => {
    const res = await axios(`http://localhost:3000/townCouncils`);
    const data = await res.data;

    return data;
  },
);

export const getSites: any = createAsyncThunk("content/getSites", async () => {
  const res = await axios(`http://localhost:3000/sites`);
  const data = await res.data;

  return data;
});

export const getBlocks: any = createAsyncThunk(
  "content/getBlocks",
  async () => {
    const res = await axios(`http://localhost:3000/blocks`);
    const data = await res.data;

    return data;
  },
);

export const getAssetchildren: any = createAsyncThunk(
  "content/assetchildren",
  async () => {
    const res = await axios(`http://localhost:3000/assetchildren`);
    const data = await res.data;

    return data;
  },
);

export const deleteAsset: any = createAsyncThunk(
  "content/deleteAsset",
  async ({ assetCode }: any) => {
    const res = await axios.delete(`slpapp/Asset`, {
      params: { assetCode },
    });

    const data = await res.data.data;
    return data;
  },
);

export const editAsset: any = createAsyncThunk(
  "content/editAsset",
  async ({ payload, assetCode }: any) => {
    const res = await axios.put(`slpapp/Asset`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
      params: { assetCode },
    });

    const data = await res.data;
    return data;
  },
);

export const updatePredictiveLighting: any = createAsyncThunk(
  "content/updatePredictiveLighting",
  async ({ assetCode, isEnabled }: any) => {
    const payload = {};
    const res = await axios.put(
      `slpapp/Asset/updatePredictiveLighting`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
        params: { assetCode, isEnabled },
      },
    );

    const data = await res.data;
    return data;
  },
);

export const uploadFile: any = createAsyncThunk(
  "content/uploadFile",
  async ({ file, isValidation }: any) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("isValidation", isValidation);

      const response = await axios.post(`slpapp/Asset`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error uploading file:", error);
      throw error;
    }
  },
);

export const getSampleFile: any = createAsyncThunk(
  "content/getFaultReports",
  async () => {
    try {
      const response = await axios.post(
        `/slpapp/Asset/downloaddemo`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        },
      );

      const fileBlob = new Blob([response.data], {
        type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;

      link.download = "AssetDemo.xlsx";

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading fault report:", error);
      throw error;
    }
  },
);

export const getBurnChartData: any = createAsyncThunk(
  "content/getBurnChartData",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/Asset/burntimeByAssetCode`, {
      params: { assetCode: id },
    });
    const data = await res.data;
    return data;
  },
);

export const getDaylightReadingData: any = createAsyncThunk(
  "content/getDaylightReadingData",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/Asset/DaylightReadingByAsset`, {
      params: { assetCode: id },
    });
    const data = await res.data;
    return data;
  },
);

export const getEnergyConsumptionData: any = createAsyncThunk(
  "content/getEnergyConsumptionData",
  async ({ id }: any) => {
    const res = await axios.get(
      `/slpapp/Asset/energyConsumptionByAssetCodeWithBaseline`,
      {
        params: { assetCode: id },
      },
    );
    const data = await res.data;
    return data;
  },
);

export const getAssetByParentAssetCode: any = createAsyncThunk(
  "content/getAssetByParentAssetCode",
  async (params) => {
    const res = await axios.get(`/slpapp/Asset/byParentAssetCode`, {
      params: params,
    });

    const data = await res.data.data.assetGroups;

    return data;
  },
);

export const getByParentAssetTypeAndCode: any = createAsyncThunk(
  "content/getByParentAssetTypeAndCode",
  async ({
    assetCode,
    luminariePageNo,
    luminariePageSize,
    sensorPageNo,
    sensorPageSize,
    SortBy,
    SortDirection,
    searchText = null,
  }: any) => {
    const res = await axios.get(`/slpapp/Asset/byParentAssetCode`, {
      params: {
        assetCode,
        luminariePageNo,
        luminariePageSize,
        sensorPageNo,
        sensorPageSize,
        SortBy,
        SortDirection,
        searchText,
      },
    });

    const data = await res.data?.data;
    return data;
  },
);

export const getMotionTrafficData: any = createAsyncThunk(
  "content/getEnerggetMotionTrafficDatayConsumptionData",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/Asset/lastDayMotionCountByAssetCode`, {
      params: { assetCode: id },
    });
    const data = await res.data;
    return data;
  },
);

export const getAssetLighteningParameters: any = createAsyncThunk(
  "content/getAssetLighteningParameters",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/Asset/assetlightingParameter`, {
      params: { assetCode: id },
    });
    const data = await res.data;
    return data;
  },
);

export const getAssetSensorParameters: any = createAsyncThunk(
  "content/getAssetSensorParameters",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/Asset/assetsensorParameter`, {
      params: { assetCode: id },
    });
    const data = await res.data;
    return data;
  },
);

export const setTriggeringZone: any = createAsyncThunk(
  "content/setTriggeringZone",
  async ({ body }: any) => {
    const res = await axios.post(
      `/slpapp/TriggeringZone/SetTriggeringZone`,
      body,
    );

    const data = await res.data;
    return data;
  },
);

export const getTriggeringZones: any = createAsyncThunk(
  "content/getTriggeringZone",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/TriggeringZone/GetTriggeringZone`, {
      params: { assetCode: id },
    });
    const data = await res.data;
    return data;
  },
);

export const deleteTriggeringZone: any = createAsyncThunk(
  "content/deleteTriggeringZone",
  async ({ zoneId }: any) => {
    const res = await axios.delete(`/slpapp/TriggeringZone`, {
      params: { zoneId },
    });
    const data = await res.data;
    return data;
  },
);

export const postAssetLighteningParameters: any = createAsyncThunk(
  "content/postAssetLighteningParameters",
  async ({ body }: any) => {
    const res = await axios.post(
      `/slpapp/SetCommand/SetLightingParameterCommandRequest`,
      body,
    );
    const data = await res.data;
    return data;
  },
);

export const postAssetSensorParameters: any = createAsyncThunk(
  "content/postAssetSensorParameters",
  async ({ body }: any) => {
    const res = await axios.post(
      `/slpapp/SetCommand/SetSensorParameterCommandRequest`,
      body,
    );
    const data = await res.data;
    return data;
  },
);

export const postTimerProfile: any = createAsyncThunk(
  "content/postTimerProfile",
  async ({ body }: any) => {
    const res = await axios.post(`/slpapp/TimerProfile/SetTimerProfile`, body);
    const data = await res.data;
    return data;
  },
);

export const enableOrDisableTimerProfile: any = createAsyncThunk(
  "content/enableOrDisableTimerProfile",
  async ({ body, isEnable, repeatAction }: any) => {
    const res = await axios.post(
      `/slpapp/TimerProfile/UpdateTimerProfile`,
      body,
      {
        params: { isEnable, repeatAction },
      },
    );
    const data = await res.data;
    return data;
  },
);

export const deleteTimerProfile: any = createAsyncThunk(
  "content/deleteTimerProfile",
  async ({ timerProfileId }: any) => {
    const res = await axios.delete(`/slpapp/TimerProfile`, {
      params: { timerProfileId },
    });

    const data = await res?.data?.data;
    return data;
  },
);

export const deleteDimmingProfile: any = createAsyncThunk(
  "content/deleteDimmingProfile",
  async ({ dimmingProfileId }: any) => {
    const res = await axios.delete(`/slpapp/DimmingProfile`, {
      params: { dimmingProfileId },
    });

    const data = await res?.data?.data;
    return data;
  },
);

export const deleteLuminanceProfile: any = createAsyncThunk(
  "content/deleteLuminanceProfile",
  async ({ luminanceProfileId }: any) => {
    const res = await axios.delete(`/slpapp/LuminanceProfile`, {
      params: { luminanceProfileId },
    });

    const data = await res?.data?.data;
    return data;
  },
);

export const postLuminanceProfile: any = createAsyncThunk(
  "content/postLuminanceProfile",
  async ({ body }: any) => {
    const res = await axios.post(
      `/slpapp/LuminanceProfile/SetLuminanceProfile`,
      body,
    );
    const data = await res.data;
    return data;
  },
);

export const enableOrDisableLuminanceProfile: any = createAsyncThunk(
  "content/enableOrDisableLuminanceProfile",
  async ({ body, isEnable, repeatAction }: any) => {
    const res = await axios.post(
      `/slpapp/LuminanceProfile/UpdateLuminanaceProfile`,
      body,
      {
        params: { isEnable, repeatAction },
      },
    );
    const data = await res.data;
    return data;
  },
);

export const postDimmingProfile: any = createAsyncThunk(
  "content/postDimmingProfile",
  async ({ body }: any) => {
    const res = await axios.post(
      `/slpapp/DimmingProfile/SetDimmingProfile`,
      body,
    );
    const data = await res.data;
    return data;
  },
);

export const enableOrDisableDimmingProfile: any = createAsyncThunk(
  "content/enableOrDisableDimmingProfile",
  async ({ body, isEnable, repeatAction }: any) => {
    const res = await axios.post(
      `/slpapp/DimmingProfile/UpdateDimmingProfile`,
      body,
      {
        params: { isEnable, repeatAction },
      },
    );
    const data = await res.data;
    return data;
  },
);

export const postDaylightProfile: any = createAsyncThunk(
  "content/postDaylightProfile",
  async ({ body }: any) => {
    const res = await axios.post(
      `/slpapp/DaylightProfile/SetDaylightProfile`,
      body,
    );
    const data = await res.data;
    return data;
  },
);

export const enableOrDisableDaylightProfile: any = createAsyncThunk(
  "content/enableOrDisableDaylightProfile",
  async ({ id, isEnable }: any) => {
    const res = await axios.post(
      `/slpapp/DaylightProfile/UpdateDaylightProfile`,
      {},
      {
        params: { id, isEnable },
      },
    );
    const data = await res.data;
    return data;
  },
);
export const setActiveLightTest: any = createAsyncThunk(
  "content/setActiveLightTest",
  async ({ id }: any) => {
    const res = await axios.post(
      `/slpapp/TestConfiguration/setActiveLightTest`,
      {},
      {
        params: { assetCode: id },
      },
    );
    const data = await res.data;
    return data;
  },
);

export const setELightAutoTest: any = createAsyncThunk(
  "content/setELightAutoTest",
  async ({ id, testControl }: any) => {
    const res = await axios.post(
      `/slpapp/TestConfiguration/setELightAutoTest`,
      {},
      {
        params: { assetCode: id, testControl },
      },
    );
    const data = await res.data;
    return data;
  },
);

export const setELightTest: any = createAsyncThunk(
  "content/setELightTest",
  async ({ id, emergencyTestTypeId }: any) => {
    const res = await axios.post(
      `/slpapp/TestConfiguration/setEmergencyLightTest`,
      {},
      {
        params: { assetCode: id, emergencyTestTypeId },
      },
    );
    const data = await res.data;
    return data;
  },
);

export const postRainProfile: any = createAsyncThunk(
  "content/postRainProfile",
  async ({ body }: any) => {
    const res = await axios.post(`/slpapp/RainProfile/SetRainProfile`, body);
    const data = await res.data;
    return data;
  },
);

export const getTestType: any = createAsyncThunk(
  "content/getTestType",
  async () => {
    const res = await axios.get(`/slpapp/TestType/GetSubTestType`);
    const data = await res.data;
    return data;
  },
);

export const enableOrDisableRainProfile: any = createAsyncThunk(
  "content/enableOrDisableRainProfile",
  async ({ id, isEnable }: any) => {
    const res = await axios.post(
      `/slpapp/RainProfile/UpdateRainProfile`,
      {},
      {
        params: { isEnable, id },
      },
    );
    const data = await res.data;
    return data;
  },
);

export const postDayLightHarvestingProfile: any = createAsyncThunk(
  "content/postDayLightHarvestingProfile",
  async ({ body }: any) => {
    const res = await axios.post(
      `/slpapp/DaylightHarvestingProfile/SetDaylightHarvestingProfile`,
      body,
    );
    const data = await res.data;
    return data;
  },
);

export const enableOrDisableDayLightHarvestingProfile: any = createAsyncThunk(
  "content/enableOrDisableDayLightHarvestingProfile",
  async ({ id, isEnable }: any) => {
    const res = await axios.post(
      `/slpapp/DaylightHarvestingProfile/UpdateDaylightHarvestingProfile`,
      {},
      {
        params: { id, isEnable },
      },
    );
    const data = await res.data;
    return data;
  },
);

export const getOperationModes: any = createAsyncThunk(
  "content/getOperationModes",
  async () => {
    const res = await axios.get(`/slpapp/OperationMode/OperationMode`);

    const data = await res.data;
    return data;
  },
);

export const getDetectionRanges: any = createAsyncThunk(
  "content/getDetectionRanges",
  async () => {
    const res = await axios.get(`/slpapp/DetectionRange`);

    const data = await res.data;
    return data;
  },
);

export const getAssetStatusSummary: any = createAsyncThunk(
  "content/getAssetStatusSummary",
  async ({ assetCode }: any) => {
    const res = await axios.get(`/slpapp/Asset/statusSummary`, {
      params: { assetCode },
    });

    const data = await res.data?.data;
    return data;
  },
);

export const setLightingOverride: any = createAsyncThunk(
  "content/setLightingOverride",
  async ({ body }: any) => {
    const res = await axios.post(
      `/slpapp/LightParameter/SetLightingOverride`,
      body,
    );

    const data = await res.data;
    return data;
  },
);

export const getLightingOverride: any = createAsyncThunk(
  "content/getLightingOverride",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/LightParameter/GetLightOverride`, {
      params: { assetCode: id },
    });
    const data = await res.data;
    return data;
  },
);

export const setLightIntensity: any = createAsyncThunk(
  "content/setLightIntensity",
  async ({ body }: any) => {
    const res = await axios.post(
      `/slpapp/LightParameter/SetLightIntensity`,
      body,
    );

    const data = await res.data;
    return data;
  },
);

export const getLightIntensity: any = createAsyncThunk(
  "content/getLightIntensity",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/LightParameter/GetLightIntensity`, {
      params: { assetCode: id },
    });
    const data = await res.data;
    return data;
  },
);

export const setSoftDimming: any = createAsyncThunk(
  "content/setSoftDimming",
  async ({ body }: any) => {
    const res = await axios.post(`/slpapp/LightParameter/SetSoftDimming`, body);

    const data = await res.data;
    return data;
  },
);

export const getSoftDimming: any = createAsyncThunk(
  "content/getSoftDimming",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/LightParameter/GetSoftDimming`, {
      params: { assetCode: id },
    });
    const data = await res.data;
    return data;
  },
);

export const setTimeDelay: any = createAsyncThunk(
  "content/setTimeDelay",
  async ({ body }: any) => {
    const res = await axios.post(`/slpapp/LightParameter/SetTimeDelay`, body);

    const data = await res.data;
    return data;
  },
);

export const getTimeDelay: any = createAsyncThunk(
  "content/getTimeDelay",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/LightParameter/GetTimeDelay`, {
      params: { assetCode: id },
    });
    const data = await res.data;
    return data;
  },
);

export const setMotionSensor: any = createAsyncThunk(
  "content/setMotionSensor",
  async ({ body }: any) => {
    const res = await axios.post(
      `/slpapp/SensorParameter/SetMotionSensor`,
      body,
    );

    const data = await res.data;
    return data;
  },
);

export const setPhotoSensor: any = createAsyncThunk(
  "content/setPhotoSensor",
  async ({ body }: any) => {
    const res = await axios.post(
      `/slpapp/SensorParameter/SetPhotoSensor`,
      body,
    );

    const data = await res.data;
    return data;
  },
);

export const setRainSensor: any = createAsyncThunk(
  "content/setRainSensor",
  async ({ body }: any) => {
    const res = await axios.post(`/slpapp/SensorParameter/SetRainSensor`, body);

    const data = await res.data;
    return data;
  },
);

export const getSearchedAssets: any = createAsyncThunk(
  "content/getSearchedAssets",
  async ({
    PageNumber,
    pageSize,
    searchText = null,
    blockCode = null,
    isUnassigned = false,
  }: any) => {
    const res = await axios.get(`/slpapp/Asset/SearchAssetCode`, {
      params: {
        searchText: searchText,
        blockCode: blockCode,
        isUnassigned: isUnassigned,
      },
    });

    const data = await res.data?.data;
    return data;
  },
);

export const getMainSearchedAssets: any = createAsyncThunk(
  "content/getMainSearchedAssets",
  async ({
    searchText = null,
    tcCode = null,
    siteCode = null,
    blockCode = null,
    isUnassigned = false,
  }: any) => {
    const res = await axios.get(`/slpapp/Asset/SearchAssetCode`, {
      params: {
        searchText: searchText,
        tcCode: tcCode,
        siteCode: siteCode,
        blockCode: blockCode,
        isUnassigned: isUnassigned,
      },
    });

    const data = await res.data?.data;
    return data;
  },
);

export const getAssetsByGateway: any = createAsyncThunk(
  "content/getAssetsByGateway",
  async ({ PageNumber, PageSize, searchText = "", gatewayCode }: any) => {
    const res = await axios.get(`/slpapp/Asset/AssetsByGateway`, {
      params: {
        gatewayCode: gatewayCode,
        searchText: searchText,
        PageNumber,
        PageSize,
      },
    });
    const data = await res.data;
    return data;
  },
);

export const getAssetsWithLocation: any = createAsyncThunk(
  "content/getAssetsWithLocation",
  async ({ tcCode = null, siteCode = null, blockCode = null }: any) => {
    const res = await axios.get(`/slpapp/Asset/AsstesWithLocation`, {
      params: {
        tcCode,
        siteCode,
        blockCode,
      },
    });
    const data = await res.data?.data;
    return data;
  },
);

export const getAssetsWithLocationSearch: any = createAsyncThunk(
  "content/getAssetsWithLocationSearch",
  async ({ assetCode = null }: any) => {
    const res = await axios.get(`/slpapp/Asset/AsstesWithLocationSearch`, {
      params: {
        assetCode,
      },
    });

    const data = await res.data?.data;
    return data;
  },
);

export const getMotionSensor: any = createAsyncThunk(
  "content/getMotionSensor",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/SensorParameter/GetMotionSensor`, {
      params: { assetCode: id },
    });

    const data = await res.data.data;
    return data;
  },
);
export const getPhotoSensor: any = createAsyncThunk(
  "content/getPhotoSensor",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/SensorParameter/GetPhotoSensor`, {
      params: { assetCode: id },
    });

    const data = await res.data.data;
    return data;
  },
);

export const getRainSensor: any = createAsyncThunk(
  "content/getRainSensor",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/SensorParameter/GetRainSensor`, {
      params: { assetCode: id },
    });

    const data = await res.data.data;
    return data;
  },
);

// Inventory - Asset (Search bar section)

export const getAssetResults: any = createAsyncThunk(
  "content/getAssetResults",
  async (params) => {
    const res = await axios.get(`/slpapp/Asset/GetAssetsWithLocationSearch`, {
      params: params,
    });

    const data = await res.data;
    return data;
  },
);

// Inventory Asset Table Search
export const getAssetTableSearchStatus: any = createAsyncThunk(
  "content/getAssetTableSearchStatus",
  async ({ PageNumber, pageSize, searchText, SortBy, SortDirection }: any) => {
    const res = await axios.get(`/slpapp/Asset/getallAssets`, {
      params: { PageNumber, pageSize, searchText, SortBy, SortDirection },
    });
    const data = await res.data;
    return data;
  },
);

export const getLightGroups: any = createAsyncThunk(
  "content/getLightGroups",
  async ({ gatewayCode, PageNumber, PageSize }: any) => {
    const res = await axios.get(`/slpapp/GatewayGroup`, {
      params: { gatewayCode, PageNumber, PageSize },
    });
    const data = res;
    return data;
  },
);

export const getSelectedGroupsAssets: any = createAsyncThunk(
  "content/getSelectedGroupsAssets",
  async ({ groupId, PageNumber, PageSize }: any) => {
    const res = await axios.get(`/slpapp/GatewayGroup/AssetByGroup`, {
      params: { groupId, PageNumber, PageSize },
    });
    const data = await res.data;
    return data;
  },
);

export const getGroupsByAsset: any = createAsyncThunk(
  "content/getGroupsByAsset",
  async ({ assetCode, PageNumber, PageSize }: any) => {
    const res = await axios.get(`/slpapp/GatewayGroup/GroupsByAsset`, {
      params: { assetCode, PageNumber, PageSize },
    });
    const data = await res.data;
    return data;
  },
);

export const getDaysOfWeek: any = createAsyncThunk(
  "content/getDaysOfWeek",
  async () => {
    const res = await axios.get(`/slpapp/DaysOfWeek`);
    const data = await res.data;
    return data;
  },
);
export const getGroupAckInfoByGateway: any = createAsyncThunk(
  "content/getGroupAckInfoByGateway",
  async ({ gatewayCode }: { gatewayCode: string }) => {
    const res = await axiosPrivate.post(
      `/slpapp/GatewayGroup/GetGroupAckInfoByGateway?gatewayCode=${gatewayCode}`,
    );
    return res?.data;
  },
);

export const getGroupUnAckInfoByGateway: any = createAsyncThunk(
  "content/getGroupUnAckInfoByGateway",
  async ({
    gatewayCode,
    groupId,
    PageNumber,
    PageSize,
    SortBy,
    SortDirection,
    SearchText,
  }: any) => {
    const res = await axiosPrivate.post(
      `/slpapp/GatewayGroup/GetGroupUnAckInfoByGateway`,
      null,
      {
        params: {
          gatewayCode,
          groupId,
          PageNumber,
          SortBy,
          SortDirection,
          PageSize,
          SearchText,
        },
      },
    );
    return res?.data;
  },
);

export const postGroupAssets: any = createAsyncThunk(
  "content/postGroupAssets",
  async ({ body }: any) => {
    const res = await axios.post(`/slpapp/GatewayGroup`, body);
    const data = await res.data;
    return data;
  },
);
//
export const removeGroupAssets: any = createAsyncThunk(
  "content/removeGroupAssets",
  async ({ body }: any) => {
    const res = await axios.post(
      `/slpapp/GatewayGroup/SaveCommandToGatewayByAssetCode`,
      body,
    );
    const data = await res?.data;
    return data;
  },
);

export const updateGroupAssets: any = createAsyncThunk(
  "content/updateGroupAssets",
  async ({ body }: any) => {
    const res = await axios.put(`/slpapp/GatewayGroup`, body);
    const data = await res.data;
    return data;
  },
);

//////

export const getTimerProfileByCode: any = createAsyncThunk(
  "content/getTimerProfileByCode",
  async ({ timerProfileId }: any) => {
    const res = await axios.get(`/slpapp/TimerProfile/GetTimerProfileById`, {
      params: { timerProfileId },
    });

    const data = await res?.data;
    return data;
  },
);

export const updateTimerProfile: any = createAsyncThunk(
  "content/updateTimerProfile",
  async ({ body }: any) => {
    const res = await axios.put(`/slpapp/TimerProfile`, body);
    const data = await res?.data;
    return data;
  },
);

export const getDimmingProfileByCode: any = createAsyncThunk(
  "content/getDimmingProfileByCode",
  async ({ dimmingProfileId }: any) => {
    const res = await axios.get(
      `/slpapp/DimmingProfile/GetDimmingProfileById`,
      {
        params: { dimmingProfileId },
      },
    );

    const data = await res?.data;
    return data;
  },
);

export const updateDimmingProfile: any = createAsyncThunk(
  "content/updateDimmingProfile",
  async ({ body }: any) => {
    const res = await axios.put(`/slpapp/DimmingProfile`, body);
    const data = await res?.data;
    return data;
  },
);

export const getLuminanceProfileByCode: any = createAsyncThunk(
  "content/getLuminanceProfileByCode",
  async ({ luminanceProfileId }: any) => {
    const res = await axios.get(
      `/slpapp/LuminanceProfile/GetLuminanceProfileById`,
      {
        params: { luminanceProfileId },
      },
    );

    const data = await res?.data;
    return data;
  },
);

export const updateLuminanceProfile: any = createAsyncThunk(
  "content/updateLuminanceProfile",
  async ({ body }: any) => {
    const res = await axios.put(`/slpapp/LuminanceProfile`, body);
    const data = await res?.data;
    return data;
  },
);

export const deleteGatewayGroup: any = createAsyncThunk(
  "content/deleteGatewayGroup",
  async ({ groupId }: any) => {
    const res = await axios.delete(`/slpapp/GatewayGroup`, {
      params: {
        groupId: groupId,
      },
    });
    const data = await res.data;
    return data;
  },
);

export const saveToGatewayGroup: any = createAsyncThunk(
  "content/saveToGatewayGroup",
  async ({ gatewayCode, nums }: any) => {
    const res = await axios.post(
      `/slpapp/GatewayGroup/SaveToGatewayGroup`,
      { nums },
      {
        params: {
          gatewayCode,
        },
      },
    );
    const data = await res?.data;
    return data;
  },
);

export const saveToGatewayGroupReset: any = createAsyncThunk(
  "content/saveToGatewayGroupReset",
  async ({ gatewayCode }: any) => {
    const res = await axios.post(
      `/slpapp/GatewayGroup/SaveToGatewayGroupReset`,
      {},
      {
        params: {
          gatewayCode,
        },
      },
    );
    const data = await res?.data;
    return data;
  },
);

export const resetTimerProfile: any = createAsyncThunk(
  "content/resetTimerProfile",
  async ({ assetCode }: any) => {
    const res = await axios.post(
      `/slpapp/TimerProfile/ResetTimerProfile`,
      {},
      {
        params: {
          assetCode,
        },
      },
    );
    const data = await res?.data;
    return data;
  },
);

export const resetDimmingProfile: any = createAsyncThunk(
  "content/resetDimmingProfile",
  async ({ assetCode }: any) => {
    const res = await axios.post(
      `/slpapp/DimmingProfile/ResetDimmingProfile`,
      {},
      {
        params: {
          assetCode,
        },
      },
    );
    const data = await res?.data;
    return data;
  },
);

export const resetLuminanceProfile: any = createAsyncThunk(
  "content/resetLuminanceProfile",
  async ({ assetCode }: any) => {
    const res = await axios.post(
      `/slpapp/LuminanceProfile/ResetLuminanaceProfile`,
      {},
      {
        params: {
          assetCode,
        },
      },
    );
    const data = await res?.data;
    return data;
  },
);

export const sendGetCommandToDms: any = createAsyncThunk(
  "content/sendGetCommandToDms",
  async ({ assetCode, module }: any) => {
    const res = await axios.post(`/slpapp/GetCommand/SendGetCommandToDms`, {
      assetCode,
      module,
    });
    const data = await res.data;
    return data;
  },
);

export const saveProximityLighting: any = createAsyncThunk(
  "content/saveProximityLighting",
  async ({ body }: any) => {
    const res = await axios.post(
      `/slpapp/ProximityLighting/saveProximityLighting`,
      body,
    );
    const data = await res?.data;
    return data;
  },
);

export const getProximityLighting: any = createAsyncThunk(
  "content/getProximityLighting",
  async ({ assetCode }: any) => {
    const res = await axios.get(
      `/slpapp/ProximityLighting/getProximityLighting`,
      {
        params: {
          assetCode,
        },
      },
    );
    const data = await res?.data;
    return data;
  },
);

// export const updateProximityLighting: any = createAsyncThunk(
//   "content/updateProximityLighting",
//   async ({ body }: any) => {
//     const res = await axios.post(
//       `/slpapp/ProximityLighting/updateProximityLighting`,
//       body
//     );
//     const data = await res.data;
//     return data;
//   }
// );

export const updateProximityLighting: any = createAsyncThunk(
  "content/updateProximityLighting",
  async ({ payload }: any) => {
    const res = await axios.put(
      `/slpapp/ProximityLighting/updateProximityLighting`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    const data = await res.data;
    return data;
  },
);

export const assetsByBlock: any = createAsyncThunk(
  "content/assetsByBlock",
  async ({ blockCode, PageNumber = 0, PageSize = 0, location = null }: any) => {
    const res = await axios.get(`/slpapp/Asset/AssetsByBlock`, {
      params: {
        blockCode,
        PageNumber,
        PageSize,
        location,
      },
    });
    const data = await res?.data;
    return data;
  },
);

export const assetsByBlockAndType: any = createAsyncThunk(
  "content/assetsByBlockAndType",
  async ({
    blockCode,
    assetType,
    PageNumber,
    PageSize,
    SortBy,
    SortDirection,
    searchText = null,
  }: any) => {
    const res = await axios.get(`/slpapp/Asset/AssetsByBlockAndType`, {
      params: {
        blockCode,
        assetType,
        PageNumber,
        PageSize,
        SortBy,
        SortDirection,
        searchText,
      },
    });
    const data = await res?.data;
    return data;
  },
);

export const resetAssetDetailsConfiguration: any = createAsyncThunk(
  "content/resetAssetDetailsConfiguration",
  async ({ assetCode }: any) => {
    const res = await axios.post(
      `/resetconfiguration/set`,
      {},
      {
        params: { assetCode },
      },
    );
    const data = await res.data;
    return data;
  },
);

export const getAssetSensorInfo: any = createAsyncThunk(
  "content/getAssetSensorInfo",
  async ({ assetCode }: any) => {
    const res = await axios.get(`/slpapp/SensorParameter/GetAssetSensorInfo`, {
      params: { assetCode },
    });

    //  ;
    const data = await res.data.data;
    return data;
  },
);

export const assetSlice = createSlice({
  name: "asset",
  initialState,
  reducers: {
    setSelectedAssetCode(state, action) {
      state.selectedAssetCode = action.payload;
    },
    setAssetFilter(state, action) {
      state.assetsFilter = action.payload;
    },
    setSelectedAssetType(state, action) {
      state.selectedAssetType = action.payload;
    },
    setBreadCrumbInfo: (state, action) => {
      state.breadCrumbInfo = action.payload;
    },
    setSearchedAssets: (state, action) => {
      state.searchedAssets = [];
    },
    setAssetRealTimeConfigData: (state, action) => {
      state.assetRealTimeConfigData = action.payload;
    },
    setAssetRealTimeConfigDataForSensorParameter: (state, action) => {
      state.assetRealTimeConfigDataForSensorParameter = action.payload;
    },
    setSelectedGroupsAssets: (state, action) => {
      state.selectedGroupsAssets = action.payload;
    },
    setLightProfileSocketData: (state, action) => {
      state.lightProfileSocketData = action.payload;
    },
    setAssetPendingStatus(state, action) {
      state.assetsPendingStatus = action.payload;
    },
    setSocketRealTimeUpdate(state, action) {
      state.socketRealTimeUpdate = action.payload;
    },
    setSocketData(state, action) {
      state.socketData = action.payload;
    },
    setSocketRealTimeUpdateData(state, action) {
      state.socketRealTimeUpdateData = action.payload;
    },

    setAssetDetails(state, action) {
      state.assetDetails = action.payload;
    },

    setAssetMainSearchFilter(state, action) {
      state.assetMainSearchFilter = action.payload;
    },
    addSelectedAsset(state, action) {
      const assetCode = action.payload;
      if (!state.selectedAssets.includes(assetCode)) {
        state.selectedAssets.push(assetCode);
      }
    },
    removeSelectedAsset(state, action) {
      state.selectedAssets = state.selectedAssets.filter(
        (code: string) => code !== action.payload
      );
    },
    clearSelectedAssets(state) {
      state.selectedAssets = [];
    },
    toggleSelectionModal(state, action) {
      state.isSelectionModalOpen = action.payload;
    },
    toggleAnalyticsModal(state, action) {
      state.isAnalyticsModalOpen = action.payload;
    },
    setAnalyticsDate(state, action) {
      state.analyticsDate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(exportAssets.pending, (state) => {
      state.isLoadingAssetExport = true;
    });
    builder.addCase(exportAssets.fulfilled, (state, action) => {
      state.isLoadingAssetExport = false;
      state.assetExport = action.payload;
    });
    builder.addCase(exportAssets.rejected, (state, action) => {
      state.isLoadingAssetExport = false;
      state.error = action.error.message;
    });

    builder.addCase(exportTotalBlocks.pending, (state) => {
      state.isLoadingBlocksExport = true;
    });
    builder.addCase(exportTotalBlocks.fulfilled, (state, action) => {
      state.isLoadingBlocksExport = false;
    });
    builder.addCase(exportTotalBlocks.rejected, (state, action) => {
      state.isLoadingBlocksExport = false;
      state.error = action.error.message;
    });

    builder.addCase(getAssets.pending, (state) => {
      state.isLoadingAssets = true;
    });
    builder.addCase(getAssets.fulfilled, (state, action) => {
      state.isLoadingAssets = false;
      state.assets = action.payload;
    });
    builder.addCase(getAssets.rejected, (state, action) => {
      state.isLoadingAssets = false;
      state.error = action.error.message;
    });

    //
    builder.addCase(sendGetCommandToDms.pending, (state) => {
      state.isLoadingCommandToDms = true;
    });
    builder.addCase(sendGetCommandToDms.fulfilled, (state, action) => {
      state.isLoadingCommandToDms = false;
    });
    builder.addCase(sendGetCommandToDms.rejected, (state, action) => {
      state.isLoadingCommandToDms = false;
      state.error = action.error.message;
    });

    builder.addCase(updateAssetLocation.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateAssetLocation.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateAssetLocation.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getAssetsByGroup.pending, (state) => {
      state.isLoadingAssetsByGroup = true;
    });
    builder.addCase(getAssetsByGroup.fulfilled, (state, action) => {
      state.isLoadingAssetsByGroup = false;
      state.assetsByGroup = action.payload;
    });
    builder.addCase(getAssetsByGroup.rejected, (state, action) => {
      state.isLoadingAssetsByGroup = false;
      state.error = action.error.message;
    });

    builder.addCase(getAssetByCode.pending, (state) => {
      state.isLoadingAssetDetails = true;
    });
    builder.addCase(getAssetByCode.fulfilled, (state, action) => {
      state.isLoadingAssetDetails = false;
      state.assetDetails = action.payload;
    });
    builder.addCase(getAssetByCode.rejected, (state, action) => {
      state.isLoadingAssetDetails = false;
      state.error = action.error.message;
    });

    builder.addCase(getAssetSingleAssetByCode.pending, (state) => {
      state.isLoadingAssetDetailsData = true;
    });
    builder.addCase(getAssetSingleAssetByCode.fulfilled, (state, action) => {
      state.isLoadingAssetDetailsData = false;
      state.assetDetailsData = action.payload;
    });
    builder.addCase(getAssetSingleAssetByCode.rejected, (state, action) => {
      state.isLoadingAssetDetailsData = false;
      state.error = action.error.message;
    });

    builder.addCase(getGatewayByBlockCode.pending, (state) => {
      state.isLoadingGatewayByBlockCode = true;
    });
    builder.addCase(getGatewayByBlockCode.fulfilled, (state, action) => {
      state.isLoadingGatewayByBlockCode = false;
      state.gatewayByBlockCode = action.payload;
    });
    builder.addCase(getGatewayByBlockCode.rejected, (state, action) => {
      state.isLoadingGatewayByBlockCode = false;
      state.error = action.error.message;
    });

    builder.addCase(getLightType.pending, (state) => {
      state.isLoadingLightType = true;
    });
    builder.addCase(getLightType.fulfilled, (state, action) => {
      state.isLoadingLightType = false;
      state.lightType = action.payload;
    });
    builder.addCase(getLightType.rejected, (state, action) => {
      state.isLoadingLightType = false;
      state.error = action.error.message;
    });

    builder.addCase(getAssetDeploymentType.pending, (state) => {
      state.isLoadingAssetDeploymentType = true;
    });
    builder.addCase(getAssetDeploymentType.fulfilled, (state, action) => {
      state.isLoadingAssetDeploymentType = false;
      state.assetDeploymentType = action.payload;
    });
    builder.addCase(getAssetDeploymentType.rejected, (state, action) => {
      state.isLoadingAssetDeploymentType = false;
      state.error = action.error.message;
    });

    builder.addCase(getTownCouncils.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getTownCouncils.fulfilled, (state, action) => {
      state.isLoading = false;
      state.townCouncils = action.payload;
    });
    builder.addCase(getTownCouncils.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(getSites.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getSites.fulfilled, (state, action) => {
      state.isLoading = false;
      state.sites = action.payload;
    });
    builder.addCase(getSites.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(getBlocks.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getBlocks.fulfilled, (state, action) => {
      state.isLoading = false;
      state.blocks = action.payload;
    });
    builder.addCase(getBlocks.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(getAssetchildren.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getAssetchildren.fulfilled, (state, action) => {
      state.isLoading = false;
      state.assetchildren = action.payload;
    });
    builder.addCase(getAssetchildren.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(deleteAsset.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteAsset.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteAsset.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(uploadFile.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(uploadFile.fulfilled, (state, action) => {
      state.isLoading = false;
      state.uploadStatusIsSuccess = true;
    });
    builder.addCase(uploadFile.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(editAsset.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(editAsset.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(editAsset.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(updatePredictiveLighting.pending, (state) => {
      state.isLoadingPredictiveLighting = true;
    });
    builder.addCase(updatePredictiveLighting.fulfilled, (state, action) => {
      state.isLoadingPredictiveLighting = false;
    });
    builder.addCase(updatePredictiveLighting.rejected, (state, action) => {
      state.isLoadingPredictiveLighting = false;
      state.error = action.error.message;
    });

    builder.addCase(getBurnChartData.pending, (state) => {
      state.isLoadingBurnChartData = true;
    });
    builder.addCase(getBurnChartData.fulfilled, (state, action) => {
      state.burnChartData = action.payload;
      state.isLoadingBurnChartData = false;
    });
    builder.addCase(getBurnChartData.rejected, (state, action) => {
      state.isLoadingBurnChartData = false;
      state.error = action.error.message;
    });

    builder.addCase(getDaylightReadingData.pending, (state) => {
      state.isLoadingDaylightReadingChartData = true;
    });
    builder.addCase(getDaylightReadingData.fulfilled, (state, action) => {
      state.daylightReadingChartData = action.payload;
      state.isLoadingDaylightReadingChartData = false;
    });
    builder.addCase(getDaylightReadingData.rejected, (state, action) => {
      state.isLoadingDaylightReadingChartData = false;
      state.error = action.error.message;
    });

    builder.addCase(getEnergyConsumptionData.pending, (state) => {
      state.isLoadingEnergyConsumptionData = true;
    });
    builder.addCase(getEnergyConsumptionData.fulfilled, (state, action) => {
      state.energyConsumptionData = action.payload;
      state.isLoadingEnergyConsumptionData = false;
    });
    builder.addCase(getEnergyConsumptionData.rejected, (state, action) => {
      state.isLoadingEnergyConsumptionData = false;
      state.error = action.error.message;
    });

    builder.addCase(getMotionTrafficData.pending, (state) => {
      state.isLoadingMotionTrafficData = true;
    });
    builder.addCase(getMotionTrafficData.fulfilled, (state, action) => {
      state.motionTrafficData = action.payload;
      state.isLoadingMotionTrafficData = false;
    });
    builder.addCase(getMotionTrafficData.rejected, (state, action) => {
      state.isLoadingMotionTrafficData = false;
      state.error = action.error.message;
    });

    builder.addCase(getAssetLighteningParameters.pending, (state) => {
      state.isLoadingLighteningParameters = true;
    });
    builder.addCase(getAssetLighteningParameters.fulfilled, (state, action) => {
      state.lighteningParameters = action.payload.data;
      state.isLoadingLighteningParameters = false;
    });
    builder.addCase(getAssetLighteningParameters.rejected, (state, action) => {
      state.isLoadingLighteningParameters = false;
      state.error = action.error.message;
    });

    builder.addCase(getLightingOverride.pending, (state) => {
      state.isLoadingLightingOverrides = true;
    });
    builder.addCase(getLightingOverride.fulfilled, (state, action) => {
      state.lightingOverrides = action.payload.data;
      state.isLoadingLightingOverrides = false;
    });
    builder.addCase(getLightingOverride.rejected, (state, action) => {
      state.isLoadingLightingOverrides = false;
      state.error = action.error.message;
    });

    builder.addCase(getSoftDimming.pending, (state) => {
      state.isLoadingSoftDimmings = true;
    });
    builder.addCase(getSoftDimming.fulfilled, (state, action) => {
      state.softDimmings = action.payload.data;
      state.isLoadingSoftDimmings = false;
    });
    builder.addCase(getSoftDimming.rejected, (state, action) => {
      state.isLoadingSoftDimmings = false;
      state.error = action.error.message;
    });

    builder.addCase(getLightIntensity.pending, (state) => {
      state.isLoadingLightIntensities = true;
    });
    builder.addCase(getLightIntensity.fulfilled, (state, action) => {
      state.lightIntensities = action.payload.data;
      state.isLoadingLightIntensities = false;
    });
    builder.addCase(getLightIntensity.rejected, (state, action) => {
      state.isLoadingLightIntensities = false;
      state.error = action.error.message;
    });

    builder.addCase(getTimeDelay.pending, (state) => {
      state.isLoadingTimeDelays = true;
    });
    builder.addCase(getTimeDelay.fulfilled, (state, action) => {
      state.timeDelays = action.payload.data;
      state.isLoadingTimeDelays = false;
    });
    builder.addCase(getTimeDelay.rejected, (state, action) => {
      state.isLoadingTimeDelays = false;
      state.error = action.error.message;
    });

    builder.addCase(getTriggeringZones.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getTriggeringZones.fulfilled, (state, action) => {
      state.triggeringZones = action.payload.data;
      state.isLoading = false;
    });
    builder.addCase(getTriggeringZones.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(deleteTriggeringZone.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteTriggeringZone.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteTriggeringZone.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getAssetSensorParameters.pending, (state) => {
      state.isLoadingSensorParameters = true;
    });
    builder.addCase(getAssetSensorParameters.fulfilled, (state, action) => {
      state.sensorParameters = action.payload.data;
      state.isLoadingSensorParameters = false;
    });
    builder.addCase(getAssetSensorParameters.rejected, (state, action) => {
      state.isLoadingSensorParameters = false;
      state.error = action.error.message;
    });

    builder.addCase(getAssetByParentAssetCode.pending, (state) => {
      state.isLoadingAssetsByParent = true;
    });
    builder.addCase(getAssetByParentAssetCode.fulfilled, (state, action) => {
      state.assetsByParent = action.payload;
      state.isLoadingAssetsByParent = false;
    });
    builder.addCase(getAssetByParentAssetCode.rejected, (state, action) => {
      state.isLoadingAssetsByParent = false;
      state.error = action.error.message;
    });

    builder.addCase(getByParentAssetTypeAndCode.pending, (state) => {
      state.isLoadingAllAssetsByParentAndType = true;
    });
    builder.addCase(getByParentAssetTypeAndCode.fulfilled, (state, action) => {
      state.allAssetsByParentAndType = action.payload;
      state.isLoadingAllAssetsByParentAndType = false;
    });
    builder.addCase(getByParentAssetTypeAndCode.rejected, (state, action) => {
      state.isLoadingAllAssetsByParentAndType = false;
      state.error = action.error.message;
    });

    builder.addCase(getOperationModes.pending, (state) => {
      state.isLoadingOperationModes = true;
    });
    builder.addCase(getOperationModes.fulfilled, (state, action) => {
      state.isLoadingOperationModes = false;
      state.operationModes = action.payload;
    });
    builder.addCase(getOperationModes.rejected, (state, action) => {
      state.isLoadingOperationModes = false;
      state.error = action.error.message;
    });

    builder.addCase(getDetectionRanges.pending, (state) => {
      state.isLoadingDetectionRanges = true;
    });
    builder.addCase(getDetectionRanges.fulfilled, (state, action) => {
      state.isLoadingDetectionRanges = false;
      state.detectionRanges = action.payload;
    });
    builder.addCase(getDetectionRanges.rejected, (state, action) => {
      state.isLoadingDetectionRanges = false;
      state.error = action.error.message;
    });

    builder.addCase(getAssetStatusSummary.pending, (state) => {
      state.isLoadingAssetSummary = true;
    });
    builder.addCase(getAssetStatusSummary.fulfilled, (state, action) => {
      state.isLoadingAssetSummary = false;
      state.assetSummary = action.payload;
    });
    builder.addCase(getAssetStatusSummary.rejected, (state, action) => {
      state.isLoadingAssetSummary = false;
      state.error = action.error.message;
    });

    builder.addCase(getSearchedAssets.pending, (state) => {
      state.isLoadingSearchedAssets = true;
    });
    builder.addCase(getSearchedAssets.fulfilled, (state, action) => {
      state.isLoadingSearchedAssets = false;
      state.searchedAssets = action.payload;
    });
    builder.addCase(getSearchedAssets.rejected, (state, action) => {
      state.isLoadingSearchedAssets = false;
      state.error = action.error.message;
    });

    builder.addCase(getMainSearchedAssets.pending, (state) => {
      state.isLoadingSearchedAssets = true;
    });
    builder.addCase(getMainSearchedAssets.fulfilled, (state, action) => {
      state.isLoadingSearchedAssets = false;
      state.searchedAssets = action.payload;
    });
    builder.addCase(getMainSearchedAssets.rejected, (state, action) => {
      state.isLoadingSearchedAssets = false;
      state.error = action.error.message;
    });

    builder.addCase(getAssetsWithLocation.pending, (state) => {
      state.isLoadingAssetsWithLocation = true;
    });
    builder.addCase(getAssetsWithLocation.fulfilled, (state, action) => {
      state.isLoadingAssetsWithLocation = false;
      state.assetsWithLocation = action.payload;
    });
    builder.addCase(getAssetsWithLocation.rejected, (state, action) => {
      state.isLoadingAssetsWithLocation = false;
      state.error = action.error.message;
    });

    builder.addCase(getAssetsWithLocationSearch.pending, (state) => {
      state.isLoadingAssetsWithLocation = true;
    });
    builder.addCase(getAssetsWithLocationSearch.fulfilled, (state, action) => {
      state.isLoadingAssetsWithLocation = false;
      state.assetsWithLocation = action.payload;
    });
    builder.addCase(getAssetsWithLocationSearch.rejected, (state, action) => {
      state.isLoadingAssetsWithLocation = false;
      state.error = action.error.message;
    });

    builder.addCase(getMotionSensor.pending, (state) => {
      state.isLoadingMotionSensor = true;
    });
    builder.addCase(getMotionSensor.fulfilled, (state, action) => {
      state.isLoadingMotionSensor = false;
      state.motionSensor = action.payload;
    });
    builder.addCase(getMotionSensor.rejected, (state, action) => {
      state.isLoadingMotionSensor = false;
      state.error = action.error.message;
    });

    builder.addCase(getPhotoSensor.pending, (state) => {
      state.isLoadingPhotoSensor = true;
    });
    builder.addCase(getPhotoSensor.fulfilled, (state, action) => {
      state.isLoadingPhotoSensor = false;
      state.photoSensor = action.payload;
    });
    builder.addCase(getPhotoSensor.rejected, (state, action) => {
      state.isLoadingPhotoSensor = false;
      state.error = action.error.message;
    });

    builder.addCase(getRainSensor.pending, (state) => {
      state.isLoadingRainSensor = true;
    });
    builder.addCase(getRainSensor.fulfilled, (state, action) => {
      state.isLoadingRainSensor = false;
      state.rainSensor = action.payload;
    });
    builder.addCase(getRainSensor.rejected, (state, action) => {
      state.isLoadingRainSensor = false;
      state.error = action.error.message;
    });

    builder.addCase(getAssetTableSearchStatus.pending, (state) => {
      state.isLoadingAssetTableStatus = true;
    });
    builder.addCase(getAssetTableSearchStatus.fulfilled, (state, action) => {
      state.isLoadingAssetTableStatus = false;
      state.assets = action.payload;
    });
    builder.addCase(getAssetTableSearchStatus.rejected, (state, action) => {
      state.isLoadingAssetTableStatus = false;
      state.error = action.error.message;
    });

    builder.addCase(getLightGroups.pending, (state) => {
      state.isLoadingLightGroups = true;
    });
    builder.addCase(getLightGroups.fulfilled, (state, action) => {
      state.isLoadingLightGroups = false;
      state.lightGroups = action.payload.data;
    });
    builder.addCase(getLightGroups.rejected, (state, action) => {
      state.isLoadingLightGroups = false;
      state.error = action.error.message;
    });

    builder.addCase(getSelectedGroupsAssets.pending, (state) => {
      state.isLoadingAssetTableStatus = true;
    });
    builder.addCase(getSelectedGroupsAssets.fulfilled, (state, action) => {
      state.isLoadingAssetTableStatus = false;
      state.selectedGroupsAssets = action.payload.data;
    });
    builder.addCase(getSelectedGroupsAssets.rejected, (state, action) => {
      state.isLoadingAssetTableStatus = false;
      state.error = action.error.message;
    });

    builder.addCase(postGroupAssets.pending, (state) => {
      state.isUpdatingGroupAssets = true;
    });
    builder.addCase(postGroupAssets.fulfilled, (state, action) => {
      state.isUpdatingGroupAssets = false;
    });
    builder.addCase(postGroupAssets.rejected, (state, action) => {
      state.isUpdatingGroupAssets = false;
      state.error = action.error.message;
    });

    builder.addCase(getGroupAckInfoByGateway.pending, (state) => {
      state.isLoadingGroupAckInfoByGateway = true;
    });
    builder.addCase(getGroupAckInfoByGateway.fulfilled, (state, action) => {
      state.groupAckInfoByGateway = action.payload.data;
      state.isLoadingGroupAckInfoByGateway = false;
    });
    builder.addCase(getGroupAckInfoByGateway.rejected, (state, action) => {
      state.isLoadingGroupAckInfoByGateway = false;
      state.error = action.error.message;
    });

    builder.addCase(getGroupUnAckInfoByGateway.pending, (state) => {
      state.isLoadingGroupUnAckInfoByGateway = true;
    });
    builder.addCase(getGroupUnAckInfoByGateway.fulfilled, (state, action) => {
      state.groupUnAckInfoByGateway = action.payload.data;
      state.isLoadingGroupUnAckInfoByGateway = false;
    });
    builder.addCase(getGroupUnAckInfoByGateway.rejected, (state, action) => {
      state.isLoadingGroupUnAckInfoByGateway = false;
      state.error = action.error.message;
    });

    builder.addCase(removeGroupAssets.pending, (state) => {
      state.isUpdatingGroupAssets = true;
    });
    builder.addCase(removeGroupAssets.fulfilled, (state, action) => {
      state.isUpdatingGroupAssets = false;
    });
    builder.addCase(removeGroupAssets.rejected, (state, action) => {
      state.isUpdatingGroupAssets = false;
      state.error = action.error.message;
    });

    builder.addCase(updateGroupAssets.pending, (state) => {
      state.isUpdatingGroupAssets = true;
    });
    builder.addCase(updateGroupAssets.fulfilled, (state, action) => {
      state.isUpdatingGroupAssets = false;
    });
    builder.addCase(updateGroupAssets.rejected, (state, action) => {
      state.isUpdatingGroupAssets = false;
      state.error = action.error.message;
    });

    builder.addCase(getAssetsByGateway.pending, (state) => {
      state.isLoadingsearchedAssetsByGateway = true;
    });
    builder.addCase(getAssetsByGateway.fulfilled, (state, action) => {
      state.searchedAssetsByGateway = action.payload.data;
      state.isLoadingsearchedAssetsByGateway = false;
    });
    builder.addCase(getAssetsByGateway.rejected, (state, action) => {
      state.isLoadingsearchedAssetsByGateway = false;
      state.error = action.error.message;
    });

    builder.addCase(getGroupsByAsset.pending, (state) => {
      state.isLoadingGroupsByAsset = true;
    });
    builder.addCase(getGroupsByAsset.fulfilled, (state, action) => {
      state.groupsByAssets = action.payload.data;
      state.isLoadingGroupsByAsset = false;
    });
    builder.addCase(getGroupsByAsset.rejected, (state, action) => {
      state.isLoadingGroupsByAsset = false;
      state.error = action.error.message;
    });

    builder.addCase(getDaysOfWeek.pending, (state) => {
      state.isLoadingDaysOfWeek = true;
    });
    builder.addCase(getDaysOfWeek.fulfilled, (state, action) => {
      state.daysOfWeek = action.payload.data;
      state.isLoadingDaysOfWeek = false;
    });
    builder.addCase(getDaysOfWeek.rejected, (state, action) => {
      state.isLoadingDaysOfWeek = false;
      state.error = action.error.message;
    });

    builder.addCase(saveToGatewayGroup.pending, (state) => {
      state.isLoadingSaveToGatewayGroup = true;
    });
    builder.addCase(saveToGatewayGroup.fulfilled, (state, action) => {
      state.isLoadingSaveToGatewayGroup = false;
    });
    builder.addCase(saveToGatewayGroup.rejected, (state, action) => {
      state.isLoadingSaveToGatewayGroup = false;
      state.error = action.error.message;
    });

    builder.addCase(saveToGatewayGroupReset.pending, (state) => {});
    builder.addCase(saveToGatewayGroupReset.fulfilled, (state, action) => {});
    builder.addCase(saveToGatewayGroupReset.rejected, (state, action) => {});

    builder.addCase(resetTimerProfile.pending, (state) => {});
    builder.addCase(resetTimerProfile.fulfilled, (state, action) => {});
    builder.addCase(resetTimerProfile.rejected, (state, action) => {});

    builder.addCase(resetDimmingProfile.pending, (state) => {});
    builder.addCase(resetDimmingProfile.fulfilled, (state, action) => {});
    builder.addCase(resetDimmingProfile.rejected, (state, action) => {});

    builder.addCase(resetLuminanceProfile.pending, (state) => {});
    builder.addCase(resetLuminanceProfile.fulfilled, (state, action) => {});
    builder.addCase(resetLuminanceProfile.rejected, (state, action) => {});

    builder.addCase(deleteGatewayGroup.pending, (state) => {
      state.isUpdatingGroupAssets = true;
    });
    builder.addCase(deleteGatewayGroup.fulfilled, (state, action) => {
      state.isUpdatingGroupAssets = false;
    });
    builder.addCase(deleteGatewayGroup.rejected, (state, action) => {
      state.isUpdatingGroupAssets = false;
      state.error = action.error.message;
    });

    builder.addCase(deleteTimerProfile.pending, (state) => {
      state.isLoadingTimerProfile = true;
    });
    builder.addCase(deleteTimerProfile.fulfilled, (state, action) => {
      state.isLoadingTimerProfile = false;
    });
    builder.addCase(deleteTimerProfile.rejected, (state, action) => {
      state.isLoadingTimerProfile = false;
      state.error = action.error.message;
    });

    /////////

    builder.addCase(getTimerProfileByCode.pending, (state) => {
      state.isLoadingTimerProfile = true;
    });
    builder.addCase(getTimerProfileByCode.fulfilled, (state, action) => {
      state.timerProfileDetails = action.payload.data;
      state.isLoadingTimerProfile = false;
    });
    builder.addCase(getTimerProfileByCode.rejected, (state, action) => {
      state.isLoadingTimerProfile = false;
      state.error = action.error.message;
    });

    builder.addCase(updateTimerProfile.pending, (state) => {
      state.isLoadingTimerProfile = true;
    });
    builder.addCase(updateTimerProfile.fulfilled, (state, action) => {
      state.isLoadingTimerProfile = false;
    });
    builder.addCase(updateTimerProfile.rejected, (state, action) => {
      state.isLoadingTimerProfile = false;
      state.error = action.error.message;
    });

    builder.addCase(deleteDimmingProfile.pending, (state) => {
      state.isLoadingDimmingProfile = true;
    });
    builder.addCase(deleteDimmingProfile.fulfilled, (state, action) => {
      state.isLoadingDimmingProfile = false;
    });
    builder.addCase(deleteDimmingProfile.rejected, (state, action) => {
      state.isLoadingDimmingProfile = false;
      state.error = action.error.message;
    });

    //
    builder.addCase(getDimmingProfileByCode.pending, (state) => {
      state.isLoadingTimerProfile = true;
    });
    builder.addCase(getDimmingProfileByCode.fulfilled, (state, action) => {
      state.dimmingProfileDetails = action.payload.data;
      state.isLoadingTimerProfile = false;
    });
    builder.addCase(getDimmingProfileByCode.rejected, (state, action) => {
      state.isLoadingTimerProfile = false;
      state.error = action.error.message;
    });

    builder.addCase(updateDimmingProfile.pending, (state) => {
      state.isLoadingDimmingProfile = true;
    });
    builder.addCase(updateDimmingProfile.fulfilled, (state, action) => {
      state.isLoadingDimmingProfile = false;
    });
    builder.addCase(updateDimmingProfile.rejected, (state, action) => {
      state.isLoadingDimmingProfile = false;
      state.error = action.error.message;
    });
    //

    builder.addCase(getLuminanceProfileByCode.pending, (state) => {
      state.isLoadingTimerProfile = true;
    });
    builder.addCase(getLuminanceProfileByCode.fulfilled, (state, action) => {
      state.luminanceProfileDetails = action.payload.data;
      state.isLoadingTimerProfile = false;
    });
    builder.addCase(getLuminanceProfileByCode.rejected, (state, action) => {
      state.isLoadingTimerProfile = false;
      state.error = action.error.message;
    });

    builder.addCase(deleteLuminanceProfile.pending, (state) => {
      state.isLoadingDimmingProfile = true;
    });
    builder.addCase(deleteLuminanceProfile.fulfilled, (state, action) => {
      state.isLoadingDimmingProfile = false;
    });
    builder.addCase(deleteLuminanceProfile.rejected, (state, action) => {
      state.isLoadingDimmingProfile = false;
      state.error = action.error.message;
    });

    builder.addCase(updateLuminanceProfile.pending, (state) => {
      state.isLoadingDimmingProfile = true;
    });
    builder.addCase(updateLuminanceProfile.fulfilled, (state, action) => {
      state.isLoadingDimmingProfile = false;
    });
    builder.addCase(updateLuminanceProfile.rejected, (state, action) => {
      state.isLoadingDimmingProfile = false;
      state.error = action.error.message;
    });

    builder.addCase(saveProximityLighting.pending, (state) => {
      state.isLoadingProximityLighting = true;
    });
    builder.addCase(saveProximityLighting.fulfilled, (state, action) => {
      state.isLoadingProximityLighting = false;
      state.proximityLighting = action.payload.data;
    });
    builder.addCase(saveProximityLighting.rejected, (state, action) => {
      state.isLoadingProximityLighting = false;
      state.error = action.error.message;
    });

    builder.addCase(getProximityLighting.pending, (state) => {
      state.isLoadingGetProximityLighting = true;
    });
    builder.addCase(getProximityLighting.fulfilled, (state, action) => {
      state.isLoadingGetProximityLighting = false;
      state.getProximityLightingDetails = action.payload.data;
    });
    builder.addCase(getProximityLighting.rejected, (state, action) => {
      state.isLoadingGetProximityLighting = false;
      state.error = action.error.message;
    });

    builder.addCase(updateProximityLighting.pending, (state) => {
      state.isLoadingUpdateProximityLighting = true;
    });
    builder.addCase(updateProximityLighting.fulfilled, (state, action) => {
      state.isLoadingUpdateProximityLighting = false;
      state.updateProximityLightingDetails = action.payload.data;
    });
    builder.addCase(updateProximityLighting.rejected, (state, action) => {
      state.isLoadingUpdateProximityLighting = false;
      state.error = action.error.message;
    });

    builder.addCase(assetsByBlock.pending, (state) => {
      state.isLoadingSelectedAssetsByBlock = true;
    });
    builder.addCase(assetsByBlock.fulfilled, (state, action) => {
      state.isLoadingSelectedAssetsByBlock = false;
      state.selectedAssetsByBlock = action.payload.data;
    });
    builder.addCase(assetsByBlock.rejected, (state, action) => {
      state.isLoadingSelectedAssetsByBlock = false;
      state.error = action.error.message;
    });

    builder.addCase(assetsByBlockAndType.pending, (state) => {
      state.isLoadingSelectedAssetsByBlockAndType = true;
    });
    builder.addCase(assetsByBlockAndType.fulfilled, (state, action) => {
      state.isLoadingSelectedAssetsByBlockAndType = false;
      state.selectedAssetsByBlockAndType = action.payload.data;
    });
    builder.addCase(assetsByBlockAndType.rejected, (state, action) => {
      state.isLoadingSelectedAssetsByBlockAndType = false;
      state.error = action.error.message;
    });

    builder.addCase(setActiveLightTest.pending, (state) => {
      state.isLoadingActiveLightTest = true;
    });
    builder.addCase(setActiveLightTest.fulfilled, (state, action) => {
      state.isLoadingActiveLightTest = false;
    });
    builder.addCase(setActiveLightTest.rejected, (state, action) => {
      state.isLoadingActiveLightTest = false;
      state.error = action.error.message;
    });

    builder.addCase(setELightAutoTest.pending, (state) => {
      state.isLoadingELightAutoTest = true;
    });
    builder.addCase(setELightAutoTest.fulfilled, (state, action) => {
      state.isLoadingELightAutoTest = false;
    });
    builder.addCase(setELightAutoTest.rejected, (state, action) => {
      state.isLoadingELightAutoTest = false;
      state.error = action.error.message;
    });

    builder.addCase(setELightTest.pending, (state) => {
      state.isLoadingELightTest = true;
    });
    builder.addCase(setELightTest.fulfilled, (state, action) => {
      state.isLoadingELightTest = false;
    });
    builder.addCase(setELightTest.rejected, (state, action) => {
      state.isLoadingELightTest = false;
      state.error = action.error.message;
    });

    builder.addCase(getTestType.pending, (state) => {
      state.isLoadingELightTest = true;
    });
    builder.addCase(getTestType.fulfilled, (state, action) => {
      state.isLoadingELightTest = false;
      state.testTypes = action.payload.data;
    });
    builder.addCase(getTestType.rejected, (state, action) => {
      state.isLoadingELightTest = false;
      state.error = action.error.message;
    });

    builder.addCase(resetAssetDetailsConfiguration.pending, (state) => {
      state.isLoadingResetAssetDetails = true;
    });
    builder.addCase(
      resetAssetDetailsConfiguration.fulfilled,
      (state, action) => {
        state.isLoadingResetAssetDetails = false;
        state.resetAssetDetails = action.payload.data;
      },
    );
    builder.addCase(
      resetAssetDetailsConfiguration.rejected,
      (state, action) => {
        state.isLoadingResetAssetDetails = false;
        state.error = action.error.message;
      },
    );

    builder.addCase(getAssetSensorInfo.pending, (state) => {
      state.isLoadingAssetSensorInfo = true;
    });
    builder.addCase(getAssetSensorInfo.fulfilled, (state, action) => {
      state.isLoadingAssetSensorInfo = false;
      state.assetSensorInfo = action.payload;
    });
    builder.addCase(getAssetSensorInfo.rejected, (state, action) => {
      state.isLoadingAssetSensorInfo = false;
      state.error = action.error.message;
    });
  },
});

export const {
  setSelectedAssetType,
  setBreadCrumbInfo,

  setAssetFilter,
  setSearchedAssets,
  setSelectedGroupsAssets,

  setAssetRealTimeConfigData,
  setAssetRealTimeConfigDataForSensorParameter,
  setLightProfileSocketData,
  setAssetPendingStatus,
  setSocketRealTimeUpdate,
  setSocketData,
  setSocketRealTimeUpdateData,
  setAssetDetails,

  setSelectedAssetCode,
  setAssetMainSearchFilter,
  addSelectedAsset,
  removeSelectedAsset,
  clearSelectedAssets,
  toggleSelectionModal,
  toggleAnalyticsModal,
  setAnalyticsDate,
} = assetSlice.actions;

export default assetSlice.reducer;
